import FormService from "../../services/FormService";
import FormInput from '../../components/FormInput';
import SelectPicker from '../../components/SelectPicker';


export default {
	components: {
		FormInput,
		SelectPicker,
	},
	data(){
		return {
			form: new FormService({
                first_name: null,
				middle_name: null,
				last_name: null,
				phone: null,
				status: null,
				is_required: false,
			}),

			modelList: [],
			modelStatus: [
				{
					"code": 5,
					"first_name": "inactive",
				},
				{
					"code": 10,
					"first_name": "active",
				},
			],
			status: 0,
		}
	},
	methods: {
		Create() {
			this.form.post('services.create')
				.then(res => {
					if (!res.errors) {
						$('#exampleModal').modal('hide');
						this.GetAll();
						this.$store.commit('successNotify')();
					}
				});
		},
		Read(id) {
			this.$api.get('services.show', id)
				.then(res => {
					// console.log(res);
					this.form.setData(res.data);
					$('#exampleModal').modal('show');
				});
		},
		Update() {
			this.form.put('services.update', this.form.id)
				.then(res => {
					if (!res.errors) {
						$('#exampleModal').modal('hide');
						this.GetAll();
						this.$store.commit('successNotify')();
					}
				});
		},
		Delete(id) {
			if (confirm('You are about to delete the record! \nAre you sure?')) {
				this.$api.delete('services.delete', id)
					.then(res => {
						if (!res.errors) {
							this.GetAll();
							this.$store.commit('successNotify')();
						}
					});
			}
		},
		GetAll() {
			this.$api.get('services.index')
				.then(res => {
					// console.log(res);
					this.modelList = res.data;
				});
		},
	},
	mounted() {
		this.GetAll();


		$('#exampleModal').on('hidden.bs.modal', (e) => {
			this.form.reset();
			this.form.is_required = false;
		})
	}
}
